// Taken from https://github.com/momentum-design/momentum-ui/blob/master/web-components/src/mixins/DedupeMixin.ts
/**
 * This mixin check thay each other mixins in the prototype chain are not applied more than once to the final component class.
 * Example:
 * import { DedupeMixin, wasApplied } from './dedupe';
 *
 * const Mixin = (superclass) => {
 *   if (wasApplied(Mixin, superclass)) { <---- Check that mixin already applied to superclass.
       return superclass;
     }

     class MixinClass extends superclass {
      // MixinClass implementation
     }

     DedupeMixin(Mixin, MixinClass); <---- If mixin not applied to superclass, save it in WeakMap to check prototype chain next time.

     return MixinClass;
 * }
 */
const appliedMixins = new WeakMap();
export const wasApplied = (mixin, superClass) => {
    const entries = appliedMixins.get(mixin);
    let proto = superClass;
    const chain = [];
    while (proto) {
        chain.push(proto);
        proto = Object.getPrototypeOf(proto);
    }
    return entries ? chain.reduce((res, protoClass) => res || entries.has(protoClass), false) : false;
};
export const DedupeMixin = (mixin, superClass) => {
    let entries = appliedMixins.get(mixin);
    if (!entries) {
        entries = new WeakSet();
        appliedMixins.set(mixin, entries);
    }
    entries.add(superClass);
};
//# sourceMappingURL=dedupe.js.map